'use client';

import { MouseEventHandler, useState } from 'react';

import FormActionButton, {
  type FormActionButtonProps,
} from '../FormActionButton';

export type SubmitButtonProps = FormActionButtonProps;

export const SubmitButton = ({
  children,
  loading,
  onClick,
  ...props
}: SubmitButtonProps) => {
  const [working, setWorking] = useState(false);

  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (loading || working) return;

    setWorking(true);

    if (typeof onClick === 'function') {
      onClick(e);
    }

    setWorking(false);
  };

  return (
    <FormActionButton
      data-testid="submit-button"
      {...props}
      loading={loading || working}
      onClick={handleClick}
    >
      {children}
    </FormActionButton>
  );
};

export default SubmitButton;
